import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=128aad93&scoped=true&"
import script from "./CustomerService.vue?vue&type=script&lang=ts&"
export * from "./CustomerService.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=128aad93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128aad93",
  null
  
)

export default component.exports